module.exports = __webpack_public_path__ + "img/pngwing.com (16).46d4ea74.png";